module.exports = __webpack_public_path__ + "img/article-2-1.c75f30fd.jpg";